import React from 'react';
import Aboutus from  "./Component/Aboutus";
import biosol from "./img/biosolution.jpg";
import Navbar from "./Component/Navbar";
import Footer from "./Component/Footer";
const About = () =>{
    return(
        <>
        <Navbar/>
        <div className="about-img"  > 
        <img src={biosol} alt="biosol" style={{"width":"100%", "height":"70vh"}}  />
        </div>
        <Aboutus/>
        <div className="about-section">
        <div className="inner-container">
            <h1>About Us</h1>
            <hr/>
            <p className="text">
            Supreme Biosolution is pioneer in manufacturing of specialty heath care products 
            in the field of aquaculture with the self commitment to provide the best quality to the 
            customers. <br/>Our core strength is relentless passion, expertise of the R & D team as well as the 
            nurturing and adoption of new technologies along with the market needs.
             </p>
           
            <p className="text">
            Supreme Biosolution offers a wide-range of products including disease control 
            nutritional supplements, pond water management and other healthcare solutions in 
            aquaculture .
            </p>
            
        </div>
    </div>
    <Footer/>
        </>
    );
};

export default About;